import React from 'react';
import { useBuyerProductStore } from 'app/store/product';
import STYLE from './ProductInfoGroup.module.scss';

interface ProductSummaryProps {
    type: string;
}

export const ProductSummary: React.FC<ProductSummaryProps> = (props) => {
    const { type } = props;

    if (type === 'feature') {
        return null;
    }

    const { product } = useBuyerProductStore();

    const summary = product?.summary;

    if (!summary) {
        return null;
    }

    return (
        <div className={STYLE.summaryBox}>
            <p className={STYLE.summary}>{summary}</p>
        </div>
    );
};
